<template>
    <div>
        <div class="luetfrink-collapse text-secondary"  id="collapseHeadWindzone" data-toggle="collapse" href="#collapseWindzone" role="button" aria-expanded="false" aria-controls="collapseWindzone"> 
            <span>Windzone</span>
            <img class="luetfrink-collapse-img" src="../../assets/img/down.svg" alt="Sektion Windzone Collapse-Pfeil"> 
        </div>
        <div class="collapse show" id="collapseWindzone" tabindex="-1" @focus="focusWindzone">
            <div class="card card-body luetfrink-collapse-card" >
                <div class="form-group">
                    <label for="inPostleitzahl">Postleitzahl (optional)</label>
                    <input type="text" class="form-control form-control-sm luetfrink-input iwind" v-model="plz" @focus="focusWindzone" @input="setWindzonenObject()" id="inPostleitzahl" name="inPostleitzahl" placeholder="" >
                    <button type="button" class="btn btn-primary text-white" @focus="focusWindzone" data-action="" id="btnErmitteln" style="display:none">Ermitteln</button>
                    <p class="plzInfo" id="plzInfo"  v-if="windzoneGueltig && plz.length == 5">{{ windzonenObject.ort }}, {{windzonenObject.bundesland}}</p>
                    <p class="plzInfo" v-if="!windzoneGueltig && plz.length == 5"> Kein Treffer </p>
                </div>
                <div class="form-group">
                    <label for="inWindzone">
                        Windzone 
                        <span id="windzonetip" class="badge badge-pill badge-primary" data-toggle="tooltip" data-placement="top" title="Die Windzone können Sie der Karte entnehmen oder automatisch über die PLZ ermitteln lassen.">i</span>
                    </label>
                    <input type="number" min="1" max="4" v-model="windzone" @focus="focusWindzone" class="form-control form-control-sm luetfrink-input iwind" id="inWindzone" name="inWindzone" placeholder="" required>
                </div>
            </div>
        </div>

        <div class="luetfrink-collapse  text-secondary" id="collapseHeadStandort" data-toggle="collapse" href="#collapseStandort" role="button" aria-expanded="false" aria-controls="collapseStandort"> 
            <span>Standort</span>
            <img class="luetfrink-collapse-img" src="../../assets/img/down.svg" alt="Sektion Standort Collapse-Pfeil"> 
        </div>
        <div class="collapse show" id="collapseStandort" tabindex="-1" @focus="focusWindzone">
            <div class="card card-body luetfrink-collapse-card">
                <div class="custom-control custom-checkbox">
                    <input type="radio" value="Binnenland" v-model="standort" class="custom-control-input" name="inCheckLand" id="checkLand1" required>
                    <label class="custom-control-label" for="checkLand1">Binnenland
                    <span class="badge badge-pill badge-primary" id="tooltip-standort" data-toggle="tooltip" data-placement="top" 
                    title="Als Küstengebiete werden im Sinne der DIN EN 1991-1-4 jene Gebiete bezeichnet, 
                    die in einem Streifen entlang der Küste mit 5 km Breite landeinwärts oder auf den Inseln der Ostsee liegen.
                    Außerdem ist der „Küstenstreifen“ auch um große Seen (mind. 5 km freie Fläche) bis 5 km landeinwärts anzuwenden.">i</span></label>
                </div>
                <div class="custom-control custom-checkbox luetfrink-check">
                    <input type="radio" value="Kuestenland" v-model="standort" class="custom-control-input" name="inCheckLand" id="checkLand2"  required>
                    <label class="custom-control-label luetfrink-check" for="checkLand2">Küstenland oder Insel der Ostsee</label>
                </div>

                <div class="form-group mt-4">
                    <label for="inStandhoehe">Höhe des Bauwerkstandortes in m (bis 1100m) <span class="badge badge-pill badge-primary" data-toggle="tooltip" data-placement="top" title="Ab einer Standorthöhe von über 1100m muss die Windsogsicherung durch einen Sonderfachmann oder Statiker nachgewiesen werden!">i</span></label>
                    <input v-model="standorthoehe" v-bind:class="[standorthoehe > 1100 || standorthoehe < 0 ? 'input-notallowed' : '']" @focus="focusWindzone" type="number" max="1100" min="0" class="form-control form-control-sm luetfrink-input iwind" name="inStandhoehe" id="inStandhoehe" placeholder="" value="" required>
                </div>

                <label class="">Exponierte Lage 
                    <span class="badge badge-pill badge-primary" id="tooltip-expo" data-toggle="tooltip" data-placement="top" 
                    title="Befindet sich der Gebäudestandort an Kamm- oder Gipfellagen der Mittelgebirge, 
                    auf Inseln der Nordsee, an hügeligem Gelände oder können aufgrund besonderer Strömungsverhältnisse 
                    (z.B. Flughafennähe oder durch die umstehenden Hochhäuser) außergewöhnliche Windkräfte wirksam werden, 
                    so werden besondere Überlegungen notwendig.">i</span>
                </label>
                <div class="custom-control custom-checkbox luetfrink-check">
                    <input type="radio" value="true" class="custom-control-input" name="inCheckLage" id="checkLage1" v-model="lageExponiert" 
                    v-bind:class="[lageExponiert == 'true' ? 'input-notallowed' : '']" required>
                    <label class="custom-control-label luetfrink-check" for="checkLage1">Ja</label>
                </div>
                <div class="custom-control custom-checkbox luetfrink-check">
                    <input type="radio" value="false" class="custom-control-input" name="inCheckLage" id="checkLage2" v-model="lageExponiert" required>
                    <label class="custom-control-label luetfrink-check" for="checkLage2">Nein</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex"

export default {
    name: "WindzoneStandort",
     methods: 
    {
        ...mapActions(['changeActiveLink', 'incrementActiveTrigger', 'changeActiveContent', 'setLageExponiert', 'setWindzonenObject']),
        focusWindzone() {
            if(this.isErlaubt)
            {
                this.$store.commit('setActiveLink', "windzone")
                this.$store.commit('setActiveContent', "windzone")
            }
        },

    },
    computed: {
        ...mapGetters(['getActiveLink', 'getActiveTrigger', 'getActiveContent', 'isErlaubt']),
        ...mapState({
            lageExponiert: state => state.inputs.lageExponiert,
            windzone: state => state.inputs.windzone,
            standort: state => state.inputs.standort,
            standorthoehe: state => state.inputs.standorthoehe,
            plz: state => state.inputs.plz,
            windzonenObject: state => state.inputs.windzonenObject,
            dachpfannen: state => state.inputs.dachpfannen,
            windzoneGueltig: state => state.inputs.windzoneGueltig,
        }),
        windzone: {
            get () {
                return this.$store.state.inputs.windzone
            },
            set (value) {
                this.$store.commit('setWindzone', value)
            }
        },
        lageExponiert: {
            get () {
                return this.$store.state.inputs.lageExponiert
            },
            set (value) {
                this.$store.commit('setLageExponiert', value)
                this.focusWindzone()
            }
        },
        standorthoehe: {
            get () {
                return this.$store.state.inputs.standorthoehe
            },
            set (value) {
                this.$store.commit('setStandorthoehe', value)
            }
        },
        plz: {
            get () {
                return this.$store.state.inputs.plz
            },
            set (value) {
                this.$store.commit('setPlz', value)
            }
        },
        standort: {
              get () {
                return this.$store.state.inputs.standort
            },
            set (value) {
                this.$store.commit('setStandort', value)
            }
        }
    },
}
</script>

<style scoped>

</style>